import { Header2, InlineText1 } from '@cian/ui-kit/typography';

import { clsx } from 'clsx';
import { FC } from 'react';

import { AmenitiesGroup } from './components/AmenitiesGroup';
import { IAmenitiesProps } from './types';

import * as styles from './Amenities.css';

export const Amenities: FC<IAmenitiesProps> = props => {
  const { amenities, className } = props;

  return (
    <div className={clsx(styles['root'], className)} data-nav-tab="amenities/Удобства" id="amenities">
      <Header2 as="h2">Удобства в коворкинге</Header2>
      <div className={styles['description']}>
        <InlineText1>Включено в стоимость аренды на всей территории коворкинга</InlineText1>
      </div>
      <div className={styles['amenities']}>
        <AmenitiesGroup className={styles['amenities-group']} coworkingAmenities={amenities} />
      </div>
    </div>
  );
};

Amenities.displayName = 'Amenities';
